module.exports = {
    scssVariables: './src/styles/sgpseedcare',
    defaultLanguage: 'en',
    profileColor: {saturation: 70, brightness: 70},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}